import { Typography } from '@mui/material';
import Row from 'components/layout/Row';
import React from 'react';

export interface DetailProps {
  title?: string;
  detail: string;
}

function Detail({ title, detail }: DetailProps) {
  return (
    <Row>
      {title && (
        <Typography color="#888888" variant="caption" fontWeight="bold">
          {title}
        </Typography>
      )}
      &nbsp;
      <Typography color="#7a1414" variant="caption" fontWeight="bold">
        {detail}
      </Typography>
    </Row>
  );
}

export default Detail;
